import React, { useState, useEffect } from "react";
import { handleGetRequest } from "../../../services/GetTemplate";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { useHistory } from "react-router-dom";

function CompanyProfile() {
  const [data, setdata] = useState([]);
  const [loading, setloading] = useState([]);
  const [rows, setRows] = useState(20);
  const [first, setFirst] = useState(0);

  const handlePageChange = (event) => {
    setFirst(event.first);
    setRows(event.rows);
  };
  // const [editable, setEditable] = useState(false);

  // const url = require("url");
  // const urlObj = url.parse(document.location.href, true);
  // const groupId = urlObj?.query?.gid;
  // const dispatch = useDispatch();

  let history = useHistory();

  const handledClicked = () => {
    // setEditable(false);
    history.push(`/companyprofilesetupadd`);
  };

  useEffect(() => {
    const getdata = async () => {
      setloading(true);
      const response = await handleGetRequest(
        `zbizgateway/nonFin/getAllCompanies`
      );
      setdata(response?.data);
      setloading(false);
    };
    getdata();
  }, []); // eslint-disable-line

  const handleViewDetails = async (rowData) => {
    // setEditable(true);
    setloading(true);
    setloading(false);
    localStorage.setItem("companyIdAdmin", rowData?.companyId);
    // localStorage.setItem("editable", false);
    history.push({
      pathname: "/companydetails",
      state: { companyName: rowData?.companyName, editable: "view" },
    });
  };

  const handleEditDetails = async (rowData) => {
    // setEditable(true);
    setloading(true);
    setloading(false);
    localStorage.setItem("companyIdAdmin", rowData?.companyId);
    // localStorage.setItem("editable", true);
    history.push({
      pathname: "/companydetails",
      state: { companyName: rowData?.companyName, editable: "true" },
    });
  };

  const actionTemplate = (rowData) => {
    return (
      <div>
        <Button
          tooltip="Edit"
          icon="pi pi-pencil"
          tooltipOptions={{ position: "top" }}
          onClick={() => handleEditDetails(rowData)}
          className="p-button-rounded p-button-secondary p-mr-2"
        />
        <Button
          tooltip="View Details"
          icon="pi pi-eye"
          tooltipOptions={{ position: "top" }}
          onClick={() => handleViewDetails(rowData)}
          className="p-button-rounded p-button-warning p-mr-2"
        />
      </div>
    );
  };

  const statusTemplate = (rowData) => {
    return (
      <>
        <span
          className={
            rowData.isActive === "Y"
              ? "p-badge p-badge-success"
              : "p-badge p-badge-danger"
          }
        >
          {rowData?.isActive === "Y" ? "Active" : "Inactive"}
        </span>
      </>
    );
  };

  return (
    <div>
      <div className="page_header">
        <div
          className="Top__Btn"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <div className="d_align">
            <i
              className="pi pi-arrow-circle-left mr-1"
              onClick={() => history.goBack()}
            />
            <h3 className="mod_heading">Company Profile Setup</h3>
          </div>
          <Button
            label="Add New"
            className="Add_New"
            onClick={handledClicked}
          />
        </div>
      </div>
      <div className="card p-datatable-sm">
        <DataTable
          loading={loading}
          paginator
          paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
          rows={rows}
          first={first}
          rowsPerPageOptions={[10, 20, 50, 100, 200]}
          onPage={handlePageChange}
          value={data}
          emptyMessage="No data found."
        >
          <Column filter field="companyName" header="Company Name" />
          <Column filter field="companyCode" header="Company Code" />
          <Column filter field="accountNoT24" header="Account No T24" />
          <Column filter field="mobileNo" header="Mobile Number" />
          <Column filter field="segment.name" header="Segment" />
          <Column
            field="status"
            filterField={(rowData) =>
              rowData?.isActive === "Y" ? "Active" : "Inactive"
            }
            header="Status"
            body={statusTemplate}
            filter
            filterMatchMode="contains"
          />
          <Column body={actionTemplate} header="Action" />
        </DataTable>
      </div>
    </div>
  );
}

export default CompanyProfile;
